import { AiOutlineCloudServer, } from "react-icons/ai";
import { MdSettings, MdSecurity, MdSpeed, MdOutlineAdminPanelSettings } from "react-icons/md";

// Page Title: miniOrange Web Hosting Solution
export const webHostingData = [
    {
        title: "High-Performance Hosting",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdSpeed className='text-white fs-5' />
    },
    {
        title: "Enterprise-Grade Security",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdSecurity className='text-white fs-5' />
    },
    {
        title: "Scalable Infrastructure",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineAdminPanelSettings className='text-white fs-5' />
    },
    {
        title: "Easy Management & Control",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdSettings className='text-white fs-5' />
    },
    {
        title: "Performance-Optimized Infrastructure",
        video: false,
        videoId: "",
        videoType: "",
        icon: <AiOutlineCloudServer className='text-white fs-5' />
    }
]